// extracted by mini-css-extract-plugin
module.exports = {"OralEnglishPronunciationEvaluation":"OralEnglishPronunciationEvaluation___3Snmw","inner":"inner___2pwKE"};